// -- Controllability & Observability  --  Control Systems -------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// -- Palette -------------------------------------------------------
const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

// -- Helpers -------------------------------------------------------
function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.8">{sub}</text>}
    </g>
  );
}

function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash?'5 3':'none'} markerEnd={`url(#${marker})`}/>
      {lbl && <text x={lx||((x1+x2)/2)} y={ly||((y1+y2)/2-5)} textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>}
    </g>
  );
}

// -- Matrix bracket renderer ---------------------------------------
function MatBracket({ x, y, rows, color, cellW=54, cellH=38 }) {
  const nr = rows.length, nc = rows[0].length;
  const W = nc * cellW, H = nr * cellH;
  return (
    <g>
      <line x1={x-7} y1={y-4}   x2={x-7} y2={y+H+4}   stroke={color} strokeWidth="2.2"/>
      <line x1={x+W+5} y1={y-4} x2={x+W+5} y2={y+H+4} stroke={color} strokeWidth="2.2"/>
      <line x1={x-7} y1={y-4}   x2={x-1} y2={y-4}     stroke={color} strokeWidth="2.2"/>
      <line x1={x-7} y1={y+H+4} x2={x-1} y2={y+H+4}   stroke={color} strokeWidth="2.2"/>
      <line x1={x+W+5} y1={y-4}   x2={x+W-1} y2={y-4}   stroke={color} strokeWidth="2.2"/>
      <line x1={x+W+5} y1={y+H+4} x2={x+W-1} y2={y+H+4} stroke={color} strokeWidth="2.2"/>
      {rows.map((row, r) =>
        row.map((val, c) => {
          const cx = x + c*cellW + cellW/2;
          const cy = y + r*cellH + cellH/2;
          const isZero = val === '0';
          return (
            <g key={`${r}-${c}`}>
              <rect x={x+c*cellW+1} y={y+r*cellH+1} width={cellW-2} height={cellH-2}
                rx={3} fill={isZero ? '#fafafa' : '#fff'} stroke={isZero ? '#eee' : '#e8e0e0'} strokeWidth="0.7"/>
              <text x={cx} y={cy+5} textAnchor="middle" fontSize="11"
                fill={isZero ? '#ccc' : color} fontWeight={isZero ? '400' : '700'}
                fontFamily="'Courier New',monospace">{val}</text>
            </g>
          );
        })
      )}
    </g>
  );
}

// ====================================================================
// Diagram 1  --  Intuitive Physical Meaning (side-by-side)
// ====================================================================
function DiagramIntuition() {
  const W = 900, H = 380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Physical Intuition  --  Controllability vs Observability</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* -- LEFT: CONTROLLABILITY -- */}
        <rect x={10} y={10} width={420} height={360} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={420} height={38} rx={6} fill={BLUE} opacity="0.1"/>
        <text x={220} y={35} textAnchor="middle" fontSize="15" fill={BLUE} fontWeight="700">CONTROLLABILITY</text>

        {/* Physical analogy: thermostat */}
        <text x={220} y={60} textAnchor="middle" fontSize="11" fill="#888" fontStyle="italic">Question: Can the input u drive every state wherever we want?</text>

        {/* Controllable example: series chain */}
        <text x={24} y={86} fontSize="12" fill={GREEN} fontWeight="700">[OK] Controllable system</text>
        {/* Chain: u -> x1 -> x2 -> x3 */}
        {[
          { x:28,  label:'u', fill:LTBLU,  stroke:BLUE   },
          { x:128, label:'x1',fill:LTGRN,  stroke:GREEN  },
          { x:228, label:'x2',fill:LTGRN,  stroke:GREEN  },
          { x:328, label:'x3',fill:LTGRN,  stroke:GREEN  },
        ].map(({ x, label, fill, stroke }) => (
          <Blk key={x} x={x} y={94} w={72} h={38} fill={fill} stroke={stroke} label={label}/>
        ))}
        <Arr x1={100} y1={113} x2={128} y2={113} color={BLUE} marker="aBlue"/>
        <Arr x1={200} y1={113} x2={228} y2={113} color={GREEN} marker="aGreen"/>
        <Arr x1={300} y1={113} x2={328} y2={113} color={GREEN} marker="aGreen"/>
        <text x={220} y={148} textAnchor="middle" fontSize="10" fill={GREEN}>Input can reach all states through coupling</text>

        {/* Uncontrollable example: disconnected state */}
        <text x={24} y={172} fontSize="12" fill={RED} fontWeight="700">[X] Uncontrollable system</text>
        {[
          { x:28,  label:'u',  fill:LTBLU, stroke:BLUE  },
          { x:128, label:'x1', fill:LTGRN, stroke:GREEN },
          { x:228, label:'x2', fill:LTGRN, stroke:GREEN },
        ].map(({ x, label, fill, stroke }) => (
          <Blk key={x} x={x} y={180} w={72} h={38} fill={fill} stroke={stroke} label={label}/>
        ))}
        <Blk x={328} y={180} w={72} h={38} fill="#f5f5f5" stroke="#bbb" label="x3"/>
        <Arr x1={100} y1={199} x2={128} y2={199} color={BLUE} marker="aBlue"/>
        <Arr x1={200} y1={199} x2={228} y2={199} color={GREEN} marker="aGreen"/>
        {/* No arrow to x3 */}
        <line x1={300} y1={199} x2={328} y2={199} stroke="#ddd" strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={364} y={175} textAnchor="middle" fontSize="12" fill="#bbb">[X]</text>
        <text x={364} y={222} textAnchor="middle" fontSize="10" fill="#bbb">isolated</text>
        <text x={220} y={236} textAnchor="middle" fontSize="10" fill={RED}>x3 evolves freely  --  input cannot reach it</text>

        {/* Consequence box */}
        <rect x={20} y={252} width={400} height={108} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={220} y={270} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700">Consequence of Uncontrollability</text>
        {[
          'Cannot place all closed-loop poles arbitrarily',
          'Uncontrollable mode evolves on its own dynamics',
          'If that mode is unstable -> system cannot be stabilised by feedback',
          'If that mode is stable -> system is stabilisable (weaker condition)',
        ].map((t, i) => (
          <text key={i} x={28} y={288+i*18} fontSize="10" fill="#333">{`* ${t}`}</text>
        ))}

        {/* -- RIGHT: OBSERVABILITY -- */}
        <rect x={470} y={10} width={420} height={360} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={470} y={10} width={420} height={38} rx={6} fill={ORANGE} opacity="0.1"/>
        <text x={680} y={35} textAnchor="middle" fontSize="15" fill={ORANGE} fontWeight="700">OBSERVABILITY</text>

        <text x={680} y={60} textAnchor="middle" fontSize="11" fill="#888" fontStyle="italic">Question: Can we reconstruct every state from output y alone?</text>

        {/* Observable example */}
        <text x={484} y={86} fontSize="12" fill={GREEN} fontWeight="700">[OK] Observable system</text>
        {[
          { x:488, label:'x1', fill:LTGRN,  stroke:GREEN  },
          { x:588, label:'x2', fill:LTGRN,  stroke:GREEN  },
          { x:688, label:'x3', fill:LTGRN,  stroke:GREEN  },
          { x:788, label:'y',  fill:LTORG,  stroke:ORANGE },
        ].map(({ x, label, fill, stroke }) => (
          <Blk key={x} x={x} y={94} w={72} h={38} fill={fill} stroke={stroke} label={label}/>
        ))}
        <Arr x1={560} y1={113} x2={588} y2={113} color={GREEN} marker="aGreen"/>
        <Arr x1={660} y1={113} x2={688} y2={113} color={GREEN} marker="aGreen"/>
        <Arr x1={760} y1={113} x2={788} y2={113} color={ORANGE} marker="aOrange"/>
        {/* Arrow x1 -> y (direct contribution) */}
        <path d={`M 524,94 C 524,74 824,74 824,94`} fill="none" stroke={ORANGE} strokeWidth="1.2" strokeDasharray="4 2" opacity="0.6"/>
        <text x={680} y={148} textAnchor="middle" fontSize="10" fill={GREEN}>Every state influences y  --  all are observable</text>

        {/* Unobservable example */}
        <text x={484} y={172} fontSize="12" fill={RED} fontWeight="700">[X] Unobservable system</text>
        {[
          { x:488, label:'x1', fill:'#f5f5f5', stroke:'#bbb'  },
          { x:588, label:'x2', fill:LTGRN,     stroke:GREEN   },
          { x:688, label:'x3', fill:LTGRN,     stroke:GREEN   },
          { x:788, label:'y',  fill:LTORG,      stroke:ORANGE },
        ].map(({ x, label, fill, stroke }) => (
          <Blk key={x} x={x} y={180} w={72} h={38} fill={fill} stroke={stroke} label={label}/>
        ))}
        <Arr x1={660} y1={199} x2={688} y2={199} color={GREEN} marker="aGreen"/>
        <Arr x1={760} y1={199} x2={788} y2={199} color={ORANGE} marker="aOrange"/>
        <line x1={560} y1={199} x2={588} y2={199} stroke="#ddd" strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={524} y={175} textAnchor="middle" fontSize="12" fill="#bbb">[X]</text>
        <text x={524} y={222} textAnchor="middle" fontSize="10" fill="#bbb">hidden</text>
        <text x={680} y={236} textAnchor="middle" fontSize="10" fill={RED}>x1 never affects y  --  cannot be estimated</text>

        {/* Consequence box */}
        <rect x={480} y={252} width={400} height={108} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={680} y={270} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">Consequence of Unobservability</text>
        {[
          'Cannot build an observer (estimator) for all states',
          'Unobservable mode cannot be tracked from output',
          'If that mode is unstable -> observer-based control fails',
          'If that mode is stable -> system is detectable (weaker condition)',
        ].map((t, i) => (
          <text key={i} x={488} y={288+i*18} fontSize="10" fill="#333">{`* ${t}`}</text>
        ))}
      </svg>
      <div style={S.dCaption}>
        Controllability and Observability are dual structural properties of a state-space system. Controllability asks whether the input signal can reach and steer every state variable. Observability asks whether the output signal carries enough information to reconstruct every state variable. Both require the system's signal pathways to be fully connected  --  and both can fail when certain modes are isolated from the input or output.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 2  --  Controllability Matrix construction step by step
// ====================================================================
function DiagramControllabilityMatrix() {
  const W = 900, H = 390;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Building the Controllability Matrix C  --  Step-by-Step Construction</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Header */}
        <rect x={10} y={10} width={880} height={44} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={450} y={30} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">C = [ B  |  AB  |  A2B  |  ...  |  An-1B ]   (n x np matrix)</text>
        <text x={450} y={46} textAnchor="middle" fontSize="10" fill="#555">System is controllable  &lt;=&gt;  rank(C) = n   (full row rank)</text>

        {/* Example system: 3x3 */}
        <text x={20} y={74} fontSize="12" fill={DKRED} fontWeight="700">Example: n=3, p=1 (SISO)</text>

        {/* A matrix */}
        <text x={30} y={96} fontSize="11" fill={RED} fontWeight="700">A =</text>
        <MatBracket x={60} y={102} color={RED} cellW={46} cellH={34} rows={[
          ['0','1','0'],
          ['0','0','1'],
          ['-a0','-a1','-a2'],
        ]}/>

        {/* B matrix */}
        <text x={226} y={96} fontSize="11" fill={BLUE} fontWeight="700">B =</text>
        <MatBracket x={252} y={102} color={BLUE} cellW={38} cellH={34} rows={[
          ['0'],['0'],['1'],
        ]}/>

        {/* Step arrows */}
        <Arr x1={300} y1={120} x2={340} y2={120} color={GREEN} marker="aGreen" lbl="xA" lx={320} ly={110}/>

        {/* AB */}
        <text x={344} y={96} fontSize="11" fill={GREEN} fontWeight="700">AB =</text>
        <MatBracket x={378} y={102} color={GREEN} cellW={38} cellH={34} rows={[
          ['0'],['1'],['-a2'],
        ]}/>

        <Arr x1={426} y1={120} x2={466} y2={120} color={PURPLE} marker="aPurple" lbl="xA" lx={446} ly={110}/>

        {/* A2B */}
        <text x={470} y={96} fontSize="11" fill={PURPLE} fontWeight="700">A2B =</text>
        <MatBracket x={510} y={102} color={PURPLE} cellW={38} cellH={34} rows={[
          ['1'],['-a2'],['a22-a1'],
        ]}/>

        {/* Assembly arrow */}
        <Arr x1={558} y1={120} x2={598} y2={120} color={ORANGE} marker="aOrange" lbl="assemble" lx={578} ly={110}/>

        {/* C assembled */}
        <text x={602} y={96} fontSize="11" fill={ORANGE} fontWeight="700">C =</text>
        <MatBracket x={628} y={102} color={ORANGE} cellW={42} cellH={34} rows={[
          ['0','0','1'],
          ['0','1','-a2'],
          ['1','-a2','a22-a1'],
        ]}/>

        {/* Rank check */}
        <rect x={10} y={218} width={880} height={158} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={236} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Rank Test  --  What Full Rank Means Geometrically</text>

        {/* Three panels */}
        {[
          { x:20,  title:'rank(C) = n = 3', subtitle:'Fully Controllable', color:GREEN, bg:LTGRN,
            desc:['Columns span Rn','All states reachable','Pole placement possible'] },
          { x:310, title:'rank(C) = 2 < n', subtitle:'Not Controllable', color:RED, bg:LTRED,
            desc:['Columns span a 2D subspace','One state mode unreachable','Pole placement fails for that mode'] },
          { x:600, title:'rank(C) = 0', subtitle:'No Controllability', color:'#bbb', bg:'#f9f9f9',
            desc:['B = 0 or AB = A2B = ... = 0','Input decoupled from all states','e.g., B is zero matrix'] },
        ].map(({ x, title, subtitle, color, bg, desc }) => (
          <g key={x}>
            <rect x={x} y={244} width={270} height={122} rx={4} fill={bg} stroke={color} strokeWidth="1.5"/>
            <text x={x+135} y={262} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{title}</text>
            <text x={x+135} y={277} textAnchor="middle" fontSize="10" fill={color} fontStyle="italic">{subtitle}</text>
            {desc.map((t, i) => (
              <text key={i} x={x+10} y={295+i*18} fontSize="10" fill="#444">{`* ${t}`}</text>
            ))}
          </g>
        ))}

        {/* Numeric example note */}
        <rect x={10} y={382} width={880} height={0} rx={3} fill="none"/>
      </svg>
      <div style={S.dCaption}>
        The controllability matrix C is built by stacking the columns B, AB, A2B, ..., An-1B side by side. Each column adds information about which directions in state space the input can reach after 1, 2, 3, ... steps of system dynamics. If these n column-groups span all of Rn (full row rank), every state is reachable. The Cayley-Hamilton theorem guarantees that columns beyond An-1B are linearly dependent  --  so we only need n blocks.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 3  --  Reachable Set visualisation in state space
// ====================================================================
function DiagramReachableSet() {
  const W = 900, H = 360;

  const panels = [
    {
      x: 10, title: 'Fully Controllable', subtitle: 'rank(C)=2, n=2',
      color: GREEN, bg: LTGRN,
      // Reachable set fills all of R2
      reachable: null, // full plane
      note: 'Reachable set = entire Rn',
      noteColor: GREEN,
      vectors: [[80,0],[56,56],[0,80],[-56,56],[-80,0],[-56,-56],[0,-80],[56,-56]],
    },
    {
      x: 310, title: 'Partially Controllable', subtitle: 'rank(C)=1, n=2',
      color: ORANGE, bg: LTORG,
      // Reachable set is a line (1D subspace)
      reachable: 'line',
      note: 'Reachable set = 1D subspace',
      noteColor: ORANGE,
      vectors: [[80,20],[40,10],[0,0],[-40,-10],[-80,-20]],
    },
    {
      x: 610, title: 'Not Controllable', subtitle: 'rank(C)=0, n=2',
      color: RED, bg: LTRED,
      // Reachable set is just the origin
      reachable: 'point',
      note: 'Reachable set = {0} only',
      noteColor: RED,
      vectors: [],
    },
  ];

  const PW = 270, PH = 250;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reachable Set  --  States Accessible from the Origin with Bounded Input</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>
        {panels.map(({ x, title, subtitle, color, bg, reachable, note, noteColor, vectors }) => {
          const cx = x + PW/2, cy = 60 + PH/2;
          return (
            <g key={x}>
              <rect x={x} y={10} width={PW} height={PH+90} rx={5} fill="#fff" stroke={BORDER}/>
              <text x={x+PW/2} y={28} textAnchor="middle" fontSize="13" fill={color} fontWeight="700">{title}</text>
              <text x={x+PW/2} y={44} textAnchor="middle" fontSize="10" fill="#777" fontStyle="italic">{subtitle}</text>

              {/* Plot area */}
              <rect x={x+14} y={58} width={PW-28} height={PH} rx={3} fill="#fafafa" stroke="#eee"/>

              {/* Axes */}
              <line x1={x+14} y1={cy} x2={x+PW-14} y2={cy} stroke="#ccc" strokeWidth="1.2"/>
              <line x1={cx} y1={58} x2={cx} y2={58+PH} stroke="#ccc" strokeWidth="1.2"/>
              <text x={x+PW-18} y={cy+12} fontSize="9" fill="#aaa">x1</text>
              <text x={cx+4} y={64} fontSize="9" fill="#aaa">x2</text>

              {/* Reachable set */}
              {reachable === null && (
                <ellipse cx={cx} cy={cy} rx={(PW-40)*0.42} ry={(PH)*0.42}
                  fill={color} opacity="0.12"/>
              )}
              {reachable === null && (
                <ellipse cx={cx} cy={cy} rx={(PW-40)*0.42} ry={(PH)*0.42}
                  fill="none" stroke={color} strokeWidth="2" strokeDasharray="6 3" opacity="0.6"/>
              )}
              {reachable === 'line' && (
                <line x1={x+24} y1={cy+(PH-20)*0.22} x2={x+PW-24} y2={cy-(PH-20)*0.22}
                  stroke={color} strokeWidth="3" opacity="0.5"/>
              )}
              {reachable === 'point' && (
                <circle cx={cx} cy={cy} r={6} fill={color} opacity="0.7"/>
              )}

              {/* Reach vectors */}
              {vectors.map(([dx, dy], i) => (
                <Arr key={i}
                  x1={cx} y1={cy}
                  x2={cx+dx*0.9} y2={cy-dy*0.9}
                  color={color} marker={color===GREEN?'aGreen':color===ORANGE?'aOrange':'aRed'}/>
              ))}

              {/* Origin dot */}
              <circle cx={cx} cy={cy} r={4} fill="#555"/>
              <text x={cx+6} y={cy-6} fontSize="9" fill="#555">x0=0</text>

              {/* Note */}
              <rect x={x+10} y={58+PH+8} width={PW-20} height={28} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
              <text x={x+PW/2} y={58+PH+26} textAnchor="middle" fontSize="11" fill={noteColor} fontWeight="700">{note}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        The reachable set is the collection of all states that can be reached from the origin in finite time using any bounded input. For a fully controllable 2D system the reachable set is all of R2  --  any target state is achievable. When rank(C)=1, only states along a single line through the origin are reachable. When rank(C)=0, the input has no effect and only the origin is reachable. The dimension of the reachable subspace equals rank(C).
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 4  --  Observability Matrix and Rank Test
// ====================================================================
function DiagramObservabilityMatrix() {
  const W = 900, H = 390;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Building the Observability Matrix O  --  Stacking Output-State Relationships</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Header */}
        <rect x={10} y={10} width={880} height={44} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={450} y={30} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">O = [ C ;  CA ;  CA2 ;  ...  ;  CAn-1 ]   (nq x n matrix)</text>
        <text x={450} y={46} textAnchor="middle" fontSize="10" fill="#555">System is observable  &lt;=&gt;  rank(O) = n   (full column rank)</text>

        {/* Example */}
        <text x={20} y={74} fontSize="12" fill={DKRED} fontWeight="700">Example: n=3, q=1 (single output)</text>

        {/* C matrix */}
        <text x={30} y={96} fontSize="11" fill={ORANGE} fontWeight="700">C =</text>
        <MatBracket x={56} y={102} color={ORANGE} cellW={46} cellH={34} rows={[['1','0','0']]}/>

        {/* A matrix */}
        <text x={198} y={96} fontSize="11" fill={RED} fontWeight="700">A =</text>
        <MatBracket x={224} y={102} color={RED} cellW={42} cellH={34} rows={[
          ['0','1','0'],
          ['0','0','1'],
          ['-a0','-a1','-a2'],
        ]}/>

        {/* Step: CA */}
        <Arr x1={396} y1={119} x2={436} y2={119} color={GREEN} marker="aGreen" lbl="CxA" lx={416} ly={109}/>
        <text x={440} y={96} fontSize="11" fill={GREEN} fontWeight="700">CA =</text>
        <MatBracket x={472} y={102} color={GREEN} cellW={46} cellH={34} rows={[['0','1','0']]}/>

        {/* Step: CA2 */}
        <Arr x1={610} y1={119} x2={650} y2={119} color={PURPLE} marker="aPurple" lbl="CA2" lx={630} ly={109}/>
        <text x={654} y={96} fontSize="11" fill={PURPLE} fontWeight="700">CA2=</text>
        <MatBracket x={692} y={102} color={PURPLE} cellW={46} cellH={34} rows={[['0','0','1']]}/>

        {/* Assembly  --  stack vertically */}
        <text x={450} y={165} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">Stack rows -&gt; O</text>
        <Arr x1={450} y1={170} x2={450} y2={188} color={ORANGE} marker="aOrange"/>

        {/* O assembled (displayed as 3x3) */}
        <text x={360} y={210} fontSize="12" fill={ORANGE} fontWeight="700">O =</text>
        <MatBracket x={392} y={188} color={ORANGE} cellW={56} cellH={34} rows={[
          ['1','0','0'],
          ['0','1','0'],
          ['0','0','1'],
        ]}/>

        <text x={570} y={210} fontSize="11" fill={GREEN} fontWeight="700">= I3   [OK]  rank = 3 = n  -&gt;  Observable!</text>

        {/* Information content panels */}
        <rect x={10} y={272} width={880} height={108} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={290} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">What Each Row-Block Tells Us</text>

        {[
          { x:20,  color:ORANGE, label:'Row C',    desc:['y(0) = Cx(0)','Direct measurement at t=0','Tells us which state combos we measure immediately'] },
          { x:230, color:GREEN,  label:'Row CA',   desc:['y_dot(0) = CAx(0)+CBu(0)','Rate of output at t=0','Reveals state info through system dynamics'] },
          { x:440, color:PURPLE, label:'Row CA2',  desc:['y(0) = CA2x(0)+...','2nd derivative of output','More state directions revealed each step'] },
          { x:650, color:TEAL,   label:'Row CAn-1', desc:['(n-1)th derivative','Final block (Cayley-Hamilton)','Together: all n dimensions spanned'] },
        ].map(({ x, color, label, desc }) => (
          <g key={x}>
            <rect x={x} y={298} width={200} height={72} rx={3} fill="#fafafa" stroke={color} strokeWidth="1"/>
            <text x={x+8} y={314} fontSize="12" fill={color} fontWeight="700">{label}</text>
            {desc.map((t, i) => (
              <text key={i} x={x+8} y={330+i*15} fontSize="9" fill="#444">{t}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The observability matrix O is built by stacking the row-blocks C, CA, CA2, ..., CAn-1. Each block represents successively deeper information about the initial state x(0) carried in the output y(t) and its derivatives. If these n row-blocks together span all of Rn (full column rank), the initial state can be uniquely recovered from output measurements. In the example above, O = I3, the identity  --  a best-case result meaning each row reveals exactly one new state.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 5  --  Numeric worked examples: rank computation
// ====================================================================
function DiagramNumericExamples() {
  const W = 900, H = 400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Worked Numeric Examples  --  Checking Controllability and Observability</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* -- Example 1: controllable & observable -- */}
        <rect x={10} y={10} width={420} height={380} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={420} height={36} rx={6} fill={GREEN} opacity="0.1"/>
        <text x={220} y={34} textAnchor="middle" fontSize="13" fill={GREEN} fontWeight="700">Example 1  --  Controllable AND Observable</text>

        {/* A, B, C */}
        <text x={24} y={62} fontSize="11" fill={RED} fontWeight="700">A =</text>
        <MatBracket x={52} y={50} color={RED} cellW={44} cellH={32} rows={[['0','1'],['-2','-3']]}/>
        <text x={168} y={62} fontSize="11" fill={BLUE} fontWeight="700">B =</text>
        <MatBracket x={192} y={50} color={BLUE} cellW={38} cellH={32} rows={[['0'],['1']]}/>
        <text x={250} y={62} fontSize="11" fill={ORANGE} fontWeight="700">C =</text>
        <MatBracket x={274} y={50} color={ORANGE} cellW={44} cellH={32} rows={[['1','0']]}/>

        {/* Controllability */}
        <text x={20} y={106} fontSize="11" fill={BLUE} fontWeight="700">Controllability Matrix C = [B | AB]:</text>
        <text x={20} y={124} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  AB = [[0,1],[-2,-3]] x [[0],[1]] = [[1],[-3]]</text>
        <MatBracket x={20} y={132} color={BLUE} cellW={44} cellH={32} rows={[['0','1'],['1','-3']]}/>
        <text x={140} y={158} fontSize="11" fill={BLUE} fontFamily="'Courier New',monospace">  det = 0x(-3) - 1x1 = -1 != 0</text>
        <rect x={20} y={168} width={390} height={28} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={215} y={187} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">[OK] rank(C) = 2 = n  -&gt;  Controllable</text>

        {/* Observability */}
        <text x={20} y={218} fontSize="11" fill={ORANGE} fontWeight="700">Observability Matrix O = [C ; CA]:</text>
        <text x={20} y={236} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  CA = [1,0] x [[0,1],[-2,-3]] = [0, 1]</text>
        <MatBracket x={20} y={244} color={ORANGE} cellW={44} cellH={32} rows={[['1','0'],['0','1']]}/>
        <text x={140} y={270} fontSize="11" fill={ORANGE} fontFamily="'Courier New',monospace">  det = 1x1 - 0x0 = 1 != 0</text>
        <rect x={20} y={280} width={390} height={28} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={215} y={299} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">[OK] rank(O) = 2 = n  -&gt;  Observable</text>

        <rect x={20} y={318} width={390} height={62} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={215} y={336} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700">Transfer Function G(s) = C(sI-A)-1B</text>
        <text x={28} y={353} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  = 1/(s2 + 3s + 2) = 1/[(s+1)(s+2)]</text>
        <text x={28} y={369} fontSize="10" fill="#444">  No pole-zero cancellation -&gt; minimal realization [OK]</text>

        {/* -- Example 2: uncontrollable (pole-zero cancellation) -- */}
        <rect x={470} y={10} width={420} height={380} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={470} y={10} width={420} height={36} rx={6} fill={RED} opacity="0.1"/>
        <text x={680} y={34} textAnchor="middle" fontSize="13" fill={RED} fontWeight="700">Example 2  --  Uncontrollable Mode</text>

        <text x={484} y={62} fontSize="11" fill={RED} fontWeight="700">A =</text>
        <MatBracket x={512} y={50} color={RED} cellW={44} cellH={32} rows={[['-1','0'],['0','-2']]}/>
        <text x={628} y={62} fontSize="11" fill={BLUE} fontWeight="700">B =</text>
        <MatBracket x={652} y={50} color={BLUE} cellW={38} cellH={32} rows={[['1'],['1']]}/>
        <text x={710} y={62} fontSize="11" fill={ORANGE} fontWeight="700">C =</text>
        <MatBracket x={734} y={50} color={ORANGE} cellW={44} cellH={32} rows={[['1','-1']]}/>

        <text x={480} y={106} fontSize="11" fill={BLUE} fontWeight="700">Controllability Matrix C = [B | AB]:</text>
        <text x={480} y={124} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  AB = [[-1,0],[0,-2]] x [[1],[1]] = [[-1],[-2]]</text>
        <MatBracket x={480} y={132} color={BLUE} cellW={44} cellH={32} rows={[['1','-1'],['1','-2']]}/>
        <text x={600} y={158} fontSize="11" fill={BLUE} fontFamily="'Courier New',monospace">  det = 1x(-2)-(-1)x1 = -1 != 0</text>
        <rect x={480} y={168} width={390} height={28} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={675} y={187} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">[OK] rank(C) = 2  -&gt;  Controllable</text>

        <text x={480} y={218} fontSize="11" fill={ORANGE} fontWeight="700">Observability Matrix O = [C ; CA]:</text>
        <text x={480} y={236} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  CA = [1,-1]x[[-1,0],[0,-2]] = [-1, 2]</text>
        <MatBracket x={480} y={244} color={ORANGE} cellW={44} cellH={32} rows={[['1','-1'],['-1','2']]}/>
        <text x={600} y={270} fontSize="11" fill={ORANGE} fontFamily="'Courier New',monospace">  det = 1x2-(-1)x(-1) = 1 != 0</text>
        <rect x={480} y={280} width={390} height={28} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={675} y={299} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">[OK] rank(O) = 2  -&gt;  Observable</text>

        <rect x={480} y={318} width={390} height={62} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={675} y={336} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">Transfer Function G(s) = C(sI-A)-1B</text>
        <text x={488} y={353} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">  = [1/(s+1)-1/(s+2)+1/(s+2)-1/(s+1)] = 0</text>
        <text x={488} y={369} fontSize="10" fill={RED} fontWeight="700">  G(s) = 0  --  hidden pole-zero cancellation!</text>
      </svg>
      <div style={S.dCaption}>
        Example 1 is a fully controllable and observable 2nd-order system  --  the controllability and observability matrices both have full rank 2, and the transfer function has no cancellations (minimal realization). Example 2 illustrates that even when both matrices have full rank, the transfer function can be identically zero due to exact pole-zero cancellation  --  a warning that rank alone doesn't tell the full story when C and B interact to create cancellations.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 6  --  PBH (Popov-Belevitch-Hautus) Eigenvalue Test
// ====================================================================
function DiagramPBH() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PBH Test  --  Eigenvalue-Based Controllability and Observability Check</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Two main test panels */}
        <rect x={10} y={10} width={420} height={260} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={420} height={36} rx={6} fill={BLUE} opacity="0.1"/>
        <text x={220} y={34} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">PBH Controllability Test</text>

        <rect x={10} y={62} width={420} height={60} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={220} y={82} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">rank[ lambdaI - A  |  B ] = n</text>
        <text x={220} y={100} textAnchor="middle" fontSize="10" fill="#555">must hold for ALL eigenvalues lambda of A</text>
        <text x={220} y={114} textAnchor="middle" fontSize="10" fill="#555">(System controllable &lt;=&gt; this rank condition holds for every lambdai)</text>

        {[
          { y:134, color:GREEN,  bg:LTGRN,  title:'Controllable mode at lambda',
            lines:['rank[lambdaI-A | B] = n  for this lambda','Input B "points into" the eigenspace','The mode can be driven by u(t)'] },
          { y:188, color:RED,    bg:LTRED,  title:'Uncontrollable mode at lambda',
            lines:['rank[lambdaI-A | B] < n  for this lambda','exists left eigenvector v: vTA=lambdavT  AND  vTB=0','B has no component in that eigendirection'] },
        ].map(({ y, color, bg, title, lines }) => (
          <g key={y}>
            <rect x={18} y={y} width={404} height={50} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={26} y={y+15} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={26} y={y+29+i*13} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}

        {/* Observability PBH */}
        <rect x={470} y={10} width={420} height={260} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={470} y={10} width={420} height={36} rx={6} fill={ORANGE} opacity="0.1"/>
        <text x={680} y={34} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700">PBH Observability Test</text>

        <rect x={470} y={62} width={420} height={60} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={680} y={82} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">rank[ lambdaI - A ;  C ] = n</text>
        <text x={680} y={100} textAnchor="middle" fontSize="10" fill="#555">must hold for ALL eigenvalues lambda of A</text>
        <text x={680} y={114} textAnchor="middle" fontSize="10" fill="#555">(System observable &lt;=&gt; this rank condition holds for every lambdai)</text>

        {[
          { y:134, color:GREEN,  bg:LTGRN,  title:'Observable mode at lambda',
            lines:['rank[lambdaI-A ; C] = n  for this lambda','Output C "sees" the eigenspace','The mode affects y(t) and can be estimated'] },
          { y:188, color:RED,    bg:LTRED,  title:'Unobservable mode at lambda',
            lines:['rank[lambdaI-A ; C] < n  for this lambda','exists right eigenvector v: Av=lambdav  AND  Cv=0','Mode lies in kernel of C  --  invisible to output'] },
        ].map(({ y, color, bg, title, lines }) => (
          <g key={y}>
            <rect x={478} y={y} width={404} height={50} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={486} y={y+15} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={486} y={y+29+i*13} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}

        {/* Advantage panel */}
        <rect x={10} y={278} width={880} height={82} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={296} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Why the PBH Test Is Powerful</text>
        {[
          { x:20,  color:BLUE,   bg:LTBLU,  lines:['Mode-by-mode diagnosis','Identifies WHICH eigenvalue causes','loss of controllability/observability'] },
          { x:240, color:ORANGE, bg:LTORG,  lines:['Numerical robustness','Can be applied via SVD of the stacked matrix','Preferred for high-order numerical systems'] },
          { x:460, color:GREEN,  bg:LTGRN,  lines:['Geometric insight','Uncontrollable &lt;=&gt; exists left eigenvector perp B','Unobservable &lt;=&gt; exists right eigenvector in ker(C)'] },
          { x:680, color:PURPLE, bg:LTPUR,  lines:['Connects to Nyquist','Loss of rank at lambda=jomega means','crossover/stability condition violated'] },
        ].map(({ x, color, bg, lines }) => (
          <g key={x}>
            <rect x={x} y={304} width={210} height={50} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            {lines.map((t, i) => (
              <text key={i} x={x+8} y={320+i*14} fontSize={i===0?'11':'9.5'} fill={i===0?color:'#444'} fontWeight={i===0?'700':'400'}>{t}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The PBH (Popov-Belevitch-Hautus) test checks controllability and observability one eigenvalue at a time by testing the rank of an augmented matrix. A mode at eigenvalue lambda is uncontrollable if and only if there exists a left eigenvector of A that is orthogonal to every column of B. Equivalently, the input cannot excite that mode. The observability PBH test checks whether any right eigenvector of A lies in the null space of C  --  meaning that mode produces zero output.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 7  --  Pole-Zero Cancellation and Hidden Modes
// ====================================================================
function DiagramPoleZero() {
  const W = 900, H = 380;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pole-Zero Cancellation  --  Hidden Uncontrollable and Unobservable Modes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* -- Left: safe cancellation (stable mode) -- */}
        <rect x={10} y={10} width={415} height={360} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={415} height={36} rx={6} fill={ORANGE} opacity="0.1"/>
        <text x={218} y={34} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">Stable Hidden Mode  --  "Safe" Cancellation</text>

        {/* Block diagram with cancelled pole */}
        <Blk x={24} y={56} w={50} h={36} fill={LTBLU} stroke={BLUE} label="u"/>
        <Arr x1={74} y1={74} x2={104} y2={74} color={BLUE} marker="aBlue"/>
        <Blk x={104} y={56} w={110} h={36} fill={LTORG} stroke={ORANGE} label="(s+3)/(s+3)" sub="G1(s)" fs={10}/>
        <Arr x1={214} y1={74} x2={244} y2={74} color={ORANGE} marker="aOrange"/>
        <Blk x={244} y={56} w={110} h={36} fill={LTBLU} stroke={BLUE} label="1/(s+1)(s+2)" sub="G2(s)" fs={10}/>
        <Arr x1={354} y1={74} x2={400} y2={74} color={BLUE} marker="aBlue"/>
        <text x={402} y={69} fontSize="12" fill={BLUE} fontWeight="700">y</text>

        {/* Cancelled TF */}
        <rect x={20} y={108} width={395} height={48} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={218} y={126} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">G(s) = (s+3)/(s+3) x 1/[(s+1)(s+2)]</text>
        <text x={218} y={144} textAnchor="middle" fontSize="11" fill={ORANGE} fontFamily="'Courier New',monospace">     = 1/[(s+1)(s+2)]   &lt;- pole at s=-3 gone!</text>

        {/* State space with hidden mode */}
        <text x={20} y={176} fontSize="11" fill={DKRED} fontWeight="700">But state-space still has 3 states:</text>
        <text x={20} y={194} fontSize="10" fill="#444">Pole at s=-3 still exists as a state variable</text>
        <text x={20} y={210} fontSize="10" fill="#444">Mode x3=e^&#123;-3t&#125; decays on its own  --  stable, but hidden</text>

        {/* s-plane */}
        {(() => {
          const cx = 218, cy = 290, sc = 45;
          const toX = r => cx + r*sc;
          const toY = i => cy - i*sc;
          return (
            <g>
              <rect x={20} y={222} width={395} height={130} rx={3} fill="#fafafa" stroke="#eee"/>
              <line x1={20} y1={cy} x2={415} y2={cy} stroke="#ccc" strokeWidth="1"/>
              <line x1={cx} y1={222} x2={cx} y2={352} stroke={RED} strokeWidth="1.3" strokeDasharray="5 3" opacity="0.4"/>
              <text x={420} y={cy+4} fontSize="9" fill="#aaa">sigma</text>

              {/* Poles */}
              <text x={toX(-1)} y={cy+5} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">x</text>
              <text x={toX(-2)} y={cy+5} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">x</text>
              {/* Cancelled pole with circle overlay */}
              <text x={toX(-3)} y={cy+5} textAnchor="middle" fontSize="14" fill="#bbb" fontWeight="700">x</text>
              <circle cx={toX(-3)} cy={cy} r={9} fill="none" stroke={ORANGE} strokeWidth="2"/>
              <text x={toX(-1)} y={cy-12} textAnchor="middle" fontSize="9" fill={RED}>TF pole</text>
              <text x={toX(-2)} y={cy-12} textAnchor="middle" fontSize="9" fill={RED}>TF pole</text>
              <text x={toX(-3)} y={cy+22} textAnchor="middle" fontSize="9" fill={ORANGE}>cancelled</text>
              <text x={toX(-3)} y={cy+34} textAnchor="middle" fontSize="9" fill={ORANGE}>(hidden, stable)</text>
            </g>
          );
        })()}

        {/* -- Right: dangerous cancellation (unstable mode) -- */}
        <rect x={475} y={10} width={415} height={360} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={475} y={10} width={415} height={36} rx={6} fill={RED} opacity="0.1"/>
        <text x={683} y={34} textAnchor="middle" fontSize="13" fill={RED} fontWeight="700">Unstable Hidden Mode  --  Dangerous!</text>

        <Blk x={489} y={56} w={50} h={36} fill={LTBLU} stroke={BLUE} label="u"/>
        <Arr x1={539} y1={74} x2={569} y2={74} color={BLUE} marker="aBlue"/>
        <Blk x={569} y={56} w={110} h={36} fill={LTRED} stroke={RED} label="(s-2)/(s-2)" sub="G1(s)" fs={10}/>
        <Arr x1={679} y1={74} x2={709} y2={74} color={RED} marker="aRed"/>
        <Blk x={709} y={56} w={110} h={36} fill={LTBLU} stroke={BLUE} label="1/(s+1)(s+2)" sub="G2(s)" fs={10}/>
        <Arr x1={819} y1={74} x2={860} y2={74} color={BLUE} marker="aBlue"/>
        <text x={862} y={69} fontSize="12" fill={BLUE} fontWeight="700">y</text>

        <rect x={485} y={108} width={395} height={48} rx={3} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={683} y={126} textAnchor="middle" fontSize="11" fill={RED} fontWeight="700">G(s) = (s-2)/(s-2) x 1/[(s+1)(s+2)]</text>
        <text x={683} y={144} textAnchor="middle" fontSize="11" fill={RED} fontFamily="'Courier New',monospace">     = 1/[(s+1)(s+2)]   &lt;- looks stable!</text>

        <text x={485} y={176} fontSize="11" fill={DKRED} fontWeight="700">DANGEROUS: unstable mode is hidden from TF:</text>
        <text x={485} y={194} fontSize="10" fill={RED}>* State-space has RHP pole at s=+2 (unstable mode)</text>
        <text x={485} y={210} fontSize="10" fill={RED}>* x3 = e^&#123;+2t&#125; grows without bound internally</text>
        <text x={485} y={226} fontSize="10" fill={RED}>* TF G(s) shows nothing wrong  --  output looks fine!</text>
        <text x={485} y={242} fontSize="10" fill={RED}>* Eventually: actuator saturation or physical failure</text>
        <text x={485} y={258} fontSize="10" fill={RED}>* Controller designed from G(s) CANNOT stabilise this</text>

        {/* s-plane */}
        {(() => {
          const cx = 683, cy = 315, sc = 45;
          const toX = r => cx + r*sc;
          const toY = i => cy - i*sc;
          return (
            <g>
              <rect x={485} y={268} width={395} height={94} rx={3} fill="#fafafa" stroke="#eee"/>
              <rect x={cx} y={268} width={395-(cx-485)} height={94} fill="#ffebee" opacity="0.3"/>
              <line x1={485} y1={cy} x2={880} y2={cy} stroke="#ccc" strokeWidth="1"/>
              <line x1={cx} y1={268} x2={cx} y2={362} stroke={RED} strokeWidth="1.3" strokeDasharray="5 3" opacity="0.5"/>

              <text x={toX(-1)} y={cy+5} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">x</text>
              <text x={toX(-2)} y={cy+5} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">x</text>
              <text x={toX(2)} y={cy+5} textAnchor="middle" fontSize="16" fill={RED} fontWeight="700">x</text>
              <circle cx={toX(2)} cy={cy} r={10} fill="none" stroke={RED} strokeWidth="2"/>
              <text x={toX(2)} y={cy-16} textAnchor="middle" fontSize="9" fill={RED} fontWeight="700">UNSTABLE!</text>
              <text x={toX(2)} y={cy+22} textAnchor="middle" fontSize="9" fill={RED}>s=+2 hidden</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>
        Pole-zero cancellation in a transfer function corresponds to an uncontrollable or unobservable mode in the state-space. If the cancelled pole is stable (left-half plane), the mode decays on its own and is merely wasteful. If the cancelled pole is unstable (right-half plane), the cancellation is catastrophic: the system has an internally unstable mode that is invisible in the transfer function  --  any controller designed from G(s) cannot stabilise the true system, which will eventually fail.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 8  --  Duality between Controllability and Observability
// ====================================================================
function DiagramDuality() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Duality Principle  --  Controllability and Observability are Mirror Images</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Centre duality arrow */}
        <line x1={420} y1={60} x2={480} y2={60} stroke={PURPLE} strokeWidth="2"/>
        <polygon points="478,54 488,60 478,66" fill={PURPLE}/>
        <polygon points="422,54 412,60 422,66" fill={PURPLE}/>
        <text x={450} y={52} textAnchor="middle" fontSize="11" fill={PURPLE} fontWeight="700">DUAL</text>

        {/* Left: Controllability system */}
        <rect x={10} y={10} width={400} height={320} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={400} height={36} rx={6} fill={BLUE} opacity="0.12"/>
        <text x={210} y={34} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">Original System (A, B, C)</text>

        {[
          { y:56,  color:BLUE,   label:'State equation',    val:'x_dot = Ax + Bu' },
          { y:82,  color:ORANGE, label:'Output equation',   val:'y = Cx + Du' },
          { y:108, color:BLUE,   label:'Controllability M', val:'C = [B  AB  A2B  ...  An-1B]' },
          { y:134, color:ORANGE, label:'Observability M',   val:'O = [CT ATCT (AT)2CT ...]T' },
          { y:160, color:GREEN,  label:'Controllable iff',  val:'rank[B AB ... An-1B] = n' },
          { y:186, color:GREEN,  label:'Observable iff',    val:'rank[CT ATCT ... ] = n' },
          { y:212, color:PURPLE, label:'Poles (open-loop)', val:'eigenvalues of A' },
          { y:238, color:RED,    label:'C.L. with feedback',val:'u=-Kx -> eig(A-BK)' },
          { y:264, color:ORANGE, label:'Observer error',    val:'e=(A-LC)e -> eig(A-LC)' },
          { y:290, color:TEAL,   label:'Gramians',          val:'AWc+WcAT+BBT=0  (controllability)' },
        ].map(({ y, color, label, val }) => (
          <g key={y}>
            <text x={20} y={y+13} fontSize="10" fill={color} fontWeight="700">{label}:</text>
            <text x={20} y={y+26} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{val}</text>
          </g>
        ))}

        {/* Right: Dual system */}
        <rect x={490} y={10} width={400} height={320} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={490} y={10} width={400} height={36} rx={6} fill={ORANGE} opacity="0.12"/>
        <text x={690} y={34} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700">Dual System (AT, CT, BT)</text>

        {[
          { y:56,  color:ORANGE, label:'State equation',    val:'z = ATz + CTv' },
          { y:82,  color:BLUE,   label:'Output equation',   val:'w = BTz' },
          { y:108, color:ORANGE, label:'Controllability M', val:'C_d = [CT ATCT ... ]' },
          { y:134, color:BLUE,   label:'Observability M',   val:'O_d = [BT BAT ... ]T' },
          { y:160, color:GREEN,  label:'Dual controllable iff', val:'original is observable' },
          { y:186, color:GREEN,  label:'Dual observable iff',   val:'original is controllable' },
          { y:212, color:PURPLE, label:'Same poles',            val:'eigenvalues of AT = eig(A)' },
          { y:238, color:RED,    label:'Observer design',       val:'L = KT from dual pole placement' },
          { y:264, color:ORANGE, label:'Design K for (A,B)',    val:'&lt;=&gt;  design LT for (AT,CT)' },
          { y:290, color:TEAL,   label:'Gramians (dual)',       val:'ATWo+WoA+CTC=0  (observability)' },
        ].map(({ y, color, label, val }) => (
          <g key={y}>
            <text x={500} y={y+13} fontSize="10" fill={color} fontWeight="700">{label}:</text>
            <text x={500} y={y+26} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{val}</text>
          </g>
        ))}

        {/* Horizontal duality arrows */}
        {[56,82,108,134,160,186,212,238,264,290].map(y => (
          <g key={y}>
            <line x1={420} y1={y+16} x2={480} y2={y+16} stroke="#ddd" strokeWidth="1" strokeDasharray="3 2"/>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Duality is one of the most elegant results in control theory: the controllability of (A, B) is exactly equivalent to the observability of the dual system (AT, CT). This means any algorithm for testing or achieving controllability can be directly applied to observability by transposing. Practically, it means observer gain L can be designed using exactly the same pole-placement algorithm as controller gain K, just applied to the dual system  --  saving substantial design effort.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 9  --  Kalman Decomposition (four-subspace structure)
// ====================================================================
function DiagramKalmanDecomposition() {
  const W = 900, H = 420;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Kalman Decomposition  --  Four Structural Subspaces of a Linear System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Large decomposition diagram */}
        {/* Four quadrant boxes */}
        {(() => {
          const boxes = [
            { x:40,  y:50,  w:230, h:140, color:GREEN,  fill:LTGRN,  label:'x_co',   title:'Controllable & Observable',  desc:['Appears in TF G(s)', 'Pole placement works', 'Observer works', 'The "useful" subspace'] },
            { x:310, y:50,  w:230, h:140, color:BLUE,   fill:LTBLU,  label:'x_c',    title:'Controllable, NOT Observable', desc:['Does NOT appear in G(s)', 'Can be driven by u', 'But not seen in y', 'Hidden controllable mode'] },
            { x:40,  y:230, w:230, h:140, color:ORANGE, fill:LTORG,  label:'x_o',    title:'Observable, NOT Controllable', desc:['Does NOT appear in G(s)', 'Cannot be driven by u', 'But visible in y', 'Unforced observable mode'] },
            { x:310, y:230, w:230, h:140, color:RED,    fill:LTRED,  label:'x_nc',   title:'Neither Controllable nor Observable', desc:['Never appears in G(s)', 'Cannot reach or see', 'Completely isolated', 'Always hidden from TF'] },
          ];

          return boxes.map(({ x, y, w, h, color, fill, label, title, desc }) => (
            <g key={label}>
              <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={color} strokeWidth="2"/>
              <text x={x+w/2} y={y+22} textAnchor="middle" fontSize="22" fill={color} fontWeight="700" fontFamily="'Courier New',monospace">{label}</text>
              <text x={x+w/2} y={y+40} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">{title}</text>
              {desc.map((t, i) => (
                <text key={i} x={x+10} y={y+58+i*19} fontSize="10" fill="#444">{`* ${t}`}</text>
              ))}
            </g>
          ));
        })()}

        {/* Axis labels */}
        <text x={155} y={44} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">OBSERVABLE [OK]</text>
        <text x={425} y={44} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700">NOT OBSERVABLE [X]</text>
        <text x={30} y={122} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700" transform="rotate(-90,30,122)">CONTROLLABLE [OK]</text>
        <text x={30} y={300} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700" transform="rotate(-90,30,300)">NOT CONTROLLABLE [X]</text>

        {/* Dividing lines */}
        <line x1={40} y1={220} x2={540} y2={220} stroke="#ccc" strokeWidth="1.5" strokeDasharray="6 3"/>
        <line x1={300} y1={50} x2={300} y2={370} stroke="#ccc" strokeWidth="1.5" strokeDasharray="6 3"/>

        {/* Transfer function representation */}
        <rect x={565} y={50} width={320} height={100} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={725} y={70} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">What G(s) Captures</text>
        <rect x={575} y={78} width={300} height={30} rx={3} fill={LTGRN} stroke={GREEN} strokeWidth="1.5"/>
        <text x={725} y={99} textAnchor="middle" fontSize="12" fill={GREEN} fontWeight="700">G(s) = C_co (sI-A_co)-1 B_co</text>
        <text x={575} y={126} fontSize="10" fill="#444">Only x_co subspace contributes to G(s).</text>
        <text x={575} y={140} fontSize="10" fill="#444">Other three subspaces are INVISIBLE in TF.</text>

        {/* Change of basis */}
        <rect x={565} y={165} width={320} height={90} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={725} y={183} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Change of Basis T</text>
        <text x={575} y={200} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">x = T.x  (invertible transformation)</text>
        <text x={575} y={216} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">A = T-1AT,  B = T-1B,  C = CT</text>
        <text x={575} y={232} fontSize="10" fill="#444">T has columns = basis vectors of the 4 subspaces.</text>
        <text x={575} y={248} fontSize="10" fill="#444">Block upper-triangular A reveals coupling structure.</text>

        {/* A structure */}
        <rect x={565} y={270} width={320} height={140} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={725} y={288} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Block Structure of A</text>
        <MatBracket x={580} y={298} color={PURPLE} cellW={56} cellH={38} rows={[
          ['A_co','*','*','*'],
          ['0','A_c','*','*'],
          ['0','0','A_o','*'],
          ['0','0','0','A_nc'],
        ]}/>
        <text x={820} y={315} fontSize="9" fill={GREEN}>&lt;- co</text>
        <text x={820} y={353} fontSize="9" fill={BLUE}>&lt;- c</text>
        <text x={820} y={391} fontSize="9" fill={ORANGE}>&lt;- o</text>
        <text x={820} y={407} fontSize="9" fill={RED}>&lt;- nc</text>
      </svg>
      <div style={S.dCaption}>
        The Kalman decomposition uses an invertible change of basis to reveal the four canonical subspaces of any LTI system. The upper-triangular block structure of A shows which subspaces couple to which. Only the controllable-and-observable subspace (x_co) contributes to the transfer function G(s)  --  the other three subspaces produce hidden dynamics. A minimal realization contains only x_co. This decomposition is the theoretical foundation for model reduction: irrelevant subspaces can be discarded without changing G(s).
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 10  --  Gramians: quantifying degree of controllability/observability
// ====================================================================
function DiagramGramians() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Gramian Matrices  --  Measuring HOW Controllable and Observable</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* -- LEFT: Controllability Gramian -- */}
        <rect x={10} y={10} width={420} height={350} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={420} height={36} rx={6} fill={BLUE} opacity="0.1"/>
        <text x={220} y={34} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">Controllability Gramian W_c</text>

        <rect x={20} y={54} width={400} height={56} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={220} y={74} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">W_c = int0^inf e^&#123;At&#125; B BT e^&#123;ATt&#125; dt</text>
        <text x={220} y={92} textAnchor="middle" fontSize="10" fill="#555">Satisfies Lyapunov: A W_c + W_c AT + B BT = 0</text>
        <text x={220} y={104} textAnchor="middle" fontSize="10" fill="#555">(solved efficiently for stable A)</text>

        {[
          { y:120, color:GREEN,  bg:LTGRN,  title:'W_c > 0 (positive definite)',   lines:['System is fully controllable','All states can be driven by input','rank(W_c) = n'] },
          { y:178, color:ORANGE, bg:LTORG,  title:'W_c >= 0 (positive semi-def.)',  lines:['System is NOT fully controllable','W_c singular: some directions unreachable','null(W_c) = uncontrollable subspace'] },
          { y:236, color:PURPLE, bg:LTPUR,  title:'Minimum energy input',           lines:['Energy to steer x0->x_f in time T:', 'J* = (x_f-e^&#123;AT&#125;x0)T W_c-1(T) (x_f-e^&#123;AT&#125;x0)', 'Smaller sigma_min(W_c) -> some dirs need huge energy'] },
          { y:294, color:TEAL,   bg:LTTEAL, title:'Hankel Singular Values',         lines:['sigmai = sqrt(lambdai(W_c . W_o))','Measures importance of each mode','Small sigmai -> mode can be truncated (model reduction)'] },
        ].map(({ y, color, bg, title, lines }) => (
          <g key={y}>
            <rect x={20} y={y} width={400} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={28} y={y+16} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={28} y={y+30+i*14} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}

        {/* -- RIGHT: Observability Gramian -- */}
        <rect x={470} y={10} width={420} height={350} rx={6} fill="#fff" stroke={BORDER}/>
        <rect x={470} y={10} width={420} height={36} rx={6} fill={ORANGE} opacity="0.1"/>
        <text x={680} y={34} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700">Observability Gramian W_o</text>

        <rect x={480} y={54} width={400} height={56} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={680} y={74} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">W_o = int0^inf e^&#123;ATt&#125; CT C e^&#123;At&#125; dt</text>
        <text x={680} y={92} textAnchor="middle" fontSize="10" fill="#555">Satisfies Lyapunov: AT W_o + W_o A + CTC = 0</text>
        <text x={680} y={104} textAnchor="middle" fontSize="10" fill="#555">(dual of controllability Gramian)</text>

        {[
          { y:120, color:GREEN,  bg:LTGRN,  title:'W_o > 0 (positive definite)',   lines:['System is fully observable','Initial state can be determined from y(t)','rank(W_o) = n'] },
          { y:178, color:RED,    bg:LTRED,  title:'W_o >= 0 (positive semi-def.)',  lines:['System is NOT fully observable','W_o singular: some initial states -> y(t)=0','null(W_o) = unobservable subspace'] },
          { y:236, color:PURPLE, bg:LTPUR,  title:'Output energy',                  lines:['||y||2 = x0T W_o x0  (zero input)', 'x0 with large W_o x0 -> easily observed', 'Directions in null(W_o) -> zero output forever'] },
          { y:294, color:TEAL,   bg:LTTEAL, title:'Balanced Realisation',           lines:['Choose T so T W_c TT = TT-1 W_o T-1 = Sigma','Sigma = diag(sigma1,...,sigman), sigmai Hankel values','Truncate small sigmai -> reduced-order model'] },
        ].map(({ y, color, bg, title, lines }) => (
          <g key={y}>
            <rect x={480} y={y} width={400} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={488} y={y+16} fontSize="11" fill={color} fontWeight="700">{title}</text>
            {lines.map((t, i) => (
              <text key={i} x={488} y={y+30+i*14} fontSize="9.5" fill="#444">{t}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        While rank tests give a binary yes/no answer, the Gramian matrices quantify the degree of controllability and observability. The controllability Gramian W_c maps desired state changes to required input energy  --  directions with small singular values of W_c require enormous control effort. The observability Gramian W_o measures how much output energy a given initial state produces. Together, the Hankel singular values sigmai = sqrtlambdai(W_c W_o) give the definitive measure of each mode's importance for model reduction.
      </div>
    </div>
  );
}

// ====================================================================
// Diagram 11  --  Stabilisability & Detectability (weaker conditions)
// ====================================================================
function DiagramStabilisability() {
  const W = 900, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stabilisability & Detectability  --  Weaker Sufficient Conditions for Control</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Four panels */}
        {[
          {
            x:10,  color:GREEN,  bg:LTGRN,
            title:'Controllable',
            sub:'(strongest)',
            lines:[
              'rank(C) = n',
              'ALL modes reachable',
              'Pole placement: any poles',
              'Implies stabilisable',
              '',
              'rank[lambdaI-A | B] = n  for alllambda',
            ],
          },
          {
            x:232, color:BLUE, bg:LTBLU,
            title:'Stabilisable',
            sub:'(weaker  --  sufficient for feedback)',
            lines:[
              'Unstable modes are controllable',
              'Stable modes may be uncontrollable',
              'Can stabilise the system by feedback',
              'Cannot place ALL poles',
              'But closed-loop can be made stable',
              'rank[lambdaI-A | B] = n  for Re(lambda)>=0',
            ],
          },
          {
            x:454, color:ORANGE, bg:LTORG,
            title:'Observable',
            sub:'(strongest)',
            lines:[
              'rank(O) = n',
              'ALL modes detectable',
              'Observer: any error poles',
              'Implies detectable',
              '',
              'rank[lambdaI-A ; C] = n  for alllambda',
            ],
          },
          {
            x:676, color:RED, bg:LTRED,
            title:'Detectable',
            sub:'(weaker  --  sufficient for observer)',
            lines:[
              'Unstable modes are observable',
              'Stable modes may be unobservable',
              'Observer error can be made stable',
              'Cannot place ALL observer poles',
              'But estimation error -> 0 eventually',
              'rank[lambdaI-A ; C] = n  for Re(lambda)>=0',
            ],
          },
        ].map(({ x, color, bg, title, sub, lines }) => (
          <g key={x}>
            <rect x={x} y={10} width={210} height={290} rx={5} fill="#fff" stroke={BORDER}/>
            <rect x={x} y={10} width={210} height={40} rx={5} fill={color} opacity="0.12"/>
            <text x={x+105} y={30} textAnchor="middle" fontSize="13" fill={color} fontWeight="700">{title}</text>
            <text x={x+105} y={44} textAnchor="middle" fontSize="9" fill={color} fontStyle="italic">{sub}</text>
            <rect x={x+8} y={58} width={194} height={234} rx={3} fill={bg} stroke={color} strokeWidth="0.8"/>
            {lines.map((t, i) => (
              <text key={i} x={x+14} y={76+i*22} fontSize="10"
                fill={t===''?'transparent':i===lines.length-1?color:'#444'}
                fontFamily={i===lines.length-1?"'Courier New',monospace":undefined}
                fontWeight={i===lines.length-1?'700':'400'}>{t || ' '}</text>
            ))}
          </g>
        ))}

        {/* Implication arrows */}
        <Arr x1={220} y1={155} x2={232} y2={155} color={GREEN} marker="aGreen" lbl="subset" lx={226} ly={147}/>
        <Arr x1={664} y1={155} x2={676} y2={155} color={ORANGE} marker="aOrange" lbl="subset" lx={670} ly={147}/>
        <text x={226} y={167} textAnchor="middle" fontSize="9" fill={GREEN}>implies</text>
        <text x={670} y={167} textAnchor="middle" fontSize="9" fill={ORANGE}>implies</text>
      </svg>
      <div style={S.dCaption}>
        Stabilisability and detectability are weaker conditions that are often sufficient in practice. Stabilisability requires only that unstable modes be controllable (stable uncontrollable modes decay on their own anyway). Detectability requires only that unstable modes be observable. For an output-feedback controller to stabilise a system, stabilisability AND detectability are the minimal necessary conditions  --  full controllability and observability are sufficient but not required.
      </div>
    </div>
  );
}

// ====================================================================
// Main
// ====================================================================
export default function ControllabilityObservability() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Controllability &amp; Observability in Control Systems</h1>
      <p style={S.p}>
        Every feedback control system rests on two fundamental structural questions about the plant: <em>Can the input reach every state?</em> (Controllability) and <em>Can the output reveal every state?</em> (Observability). These properties, first formalised by Rudolf Kalman in 1960, determine what is theoretically possible  --  whether poles can be placed arbitrarily, whether a state observer can be built, and whether a given transfer function faithfully represents the full internal dynamics. Checking them is the essential first step of any serious state-space design.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Controllability: system (A,B) is controllable iff rank[B  AB  ...  An-1B] = n",
        "Observability: system (A,C) is observable iff rank[CT  ATCT  ...  (AT)n-1CT] = n",
        "PBH test (eigenvalue): mode lambda uncontrollable iff exists left eigenvector vT with vTB=0",
        "PBH test (eigenvalue): mode lambda unobservable iff exists right eigenvector v with Cv=0",
        "Pole-zero cancellation in G(s) &lt;-&gt; uncontrollable OR unobservable internal mode",
        "Duality: (A,B) controllable &lt;=&gt; (AT,BT) observable  --  design K &lt;-&gt; design LT",
        "Kalman decomposition: any system decomposes into 4 subspaces (co, c, o, nc); G(s) uses only co",
        "Gramians W_c, W_o: quantify degree of controllability/observability; Hankel singular values for model reduction",
        "Stabilisability + Detectability: weaker conditions sufficient for output-feedback stabilisation",
      ]}/>

      <h2 style={S.h2}>Physical Intuition</h2>
      <p style={S.p}>
        Before working through formulas, it helps to understand what controllability and observability mean in physical terms. Controllability is about whether the input signal can steer every internal state variable to any desired value. Observability is about whether the output signal carries enough information to reconstruct every internal state. Both properties depend not on the numerical values of system parameters, but on the <em>connectivity structure</em> of the state-space.
      </p>
      <DiagramIntuition/>
      <Table2 rows={[
        ["Controllability  --  definition","(A, B) is controllable if for any initial state x0 and any desired final state x_f,\nthere exists a finite-time input u(t) that drives x(0)=x0 to x(T)=x_f"],
        ["Observability  --  definition","(A, C) is observable if for any unknown initial state x0,\nthere exists a finite time T>0 such that y(t) on [0,T] uniquely determines x0"],
        ["Why they matter: control","Controllable -> can place all closed-loop poles -> arbitrary transient performance\nUncontrollable -> some poles fixed by A; if those modes are unstable, system cannot be stabilised"],
        ["Why they matter: estimation","Observable -> can build Luenberger observer for all states -> full state feedback possible\nUnobservable -> some states cannot be estimated; if those modes are unstable, observer fails"],
        ["Physical examples (controllable)","Series RLC: voltage u can drive all three states (current, charges)\nMass-spring with force input: force drives both position and velocity states"],
        ["Physical examples (uncontrollable)","Two uncoupled tanks  --  pump only connected to one:\nsecond tank level evolves freely regardless of pump input"],
      ]}/>

      <h2 style={S.h2}>The Controllability Matrix</h2>
      <p style={S.p}>
        The controllability matrix C provides the definitive algebraic test. Its columns are B, AB, A2B, ..., An-1B  --  the directions in state space that the input can excite directly, after one step of dynamics, after two steps, and so on. The Cayley-Hamilton theorem guarantees we need not go beyond An-1B. If these columns collectively span all of Rn, every state is reachable.
      </p>
      <DiagramControllabilityMatrix/>
      <Table2 rows={[
        ["Controllability matrix","C = [B  AB  A2B  ...  An-1B],  size nx(np)\nFor SISO (p=1): square nxn matrix  --  rank test is det(C) != 0"],
        ["Why AB matters","AB = A.B: state reached after one step when input is B\nA2B: two steps of dynamics; reveals indirect paths from u to states"],
        ["Cayley-Hamilton theorem","An = -(a0I + a1A + ... + an-1An-1) by characteristic polynomial\nAnB and beyond are linear combinations of earlier columns  --  redundant"],
        ["Rank deficiency","rank(C) = k < n means only k directions in Rn are reachable\nThe controllable subspace is spanned by the k linearly independent columns of C"],
        ["Numerical computation","For large n, direct rank computation via SVD of C is numerically preferred\nMATLAB: Co = ctrb(A,B);  rank(Co)  or  rank(ctrb(A,B))"],
        ["Ackermann's formula","K = enT . C-1 . phi(A)  requires C invertible (square SISO, rank n)\nIf rank(C) < n, Ackermann's formula fails  --  system not fully controllable"],
      ]}/>

      <h2 style={S.h2}>The Reachable Set</h2>
      <p style={S.p}>
        The reachable set is the geometric picture of controllability: it is the set of all states that can be reached from the origin using any admissible input over any finite time interval. Its dimension is exactly rank(C). For a fully controllable system the reachable set is all of Rn; for a partially controllable system it is a strict subspace.
      </p>
      <DiagramReachableSet/>
      <Table2 rows={[
        ["Reachable subspace","Im(C) = span of columns of C = smallest A-invariant subspace containing Im(B)\nAlso written <A|B>  --  the reachability subspace"],
        ["A-invariance","The reachable subspace is A-invariant: if x is reachable, so is Ax\nThis means uncontrollable modes remain forever outside the reachable set"],
        ["Minimum-energy control","Optimal u* to reach x_f in time T: u*(t) = BT e^&#123;AT(T-t)&#125; W_c-1(T) x_f\nMinimum energy J* = x_fT W_c-1(T) x_f  (requires W_c invertible)"],
        ["Controllable subspace","Spanned by B, AB, A2B, ...: same as reachable subspace for LTI\n(Note: for some nonlinear/time-varying systems, reachable != controllable subspace)"],
        ["Uncontrollable modes","Eigenvectors of A corresponding to eigenvalues with vTB=0\nThese modes evolve freely  --  initial condition determines their trajectory, not input"],
        ["Physical dimension","n - rank(C) = number of uncontrollable state directions\nThese correspond to modes that the input simply cannot excite"],
      ]}/>

      <h2 style={S.h2}>The Observability Matrix</h2>
      <p style={S.p}>
        The observability matrix O is the dual counterpart of the controllability matrix. Its row-blocks C, CA, CA2, ..., CAn-1 represent how the initial state x0 appears in the output y(0), y_dot(0), y(0), ..., y^(n-1)(0). If these blocks collectively span all of Rn (full column rank), the initial state can be uniquely recovered from a window of output data.
      </p>
      <DiagramObservabilityMatrix/>
      <Table2 rows={[
        ["Observability matrix","O = [C; CA; CA2; ...; CAn-1],  size (nq)xn\nFor SISO (q=1): square nxn  --  rank test is det(O) != 0"],
        ["Why CA matters","y(0)=Cx0; y_dot(0)=CAx0+CBu (with u=0: =CAx0)\nEach derivative reveals more of x0 through the system dynamics"],
        ["Unobservable subspace","ker(O) = null space of O = modes invisible to the output\nSpanned by right eigenvectors v with Cv=0: mode e^(lambda*t)*v -> zero output forever"],
        ["Initial state reconstruction","If rank(O)=n: x0 = O_pinv x [y(0); y_dot(0); ...; y^(n-1)(0)]  (noise-free)\nO_pinv = pseudo-inverse; Luenberger observer is the practical recursive version"],
        ["MATLAB","Ob = obsv(A,C);  rank(Ob)  or  rank(obsv(A,C))\nAlso: obsv(sys) for state-space system objects"],
        ["Duality identity","rank(O for (A,C)) = rank(C for (AT,CT))\nThis is why observer design = pole placement for the dual system"],
      ]}/>

      <h2 style={S.h2}>Worked Numeric Examples</h2>
      <p style={S.p}>
        Abstract rank conditions become concrete when applied to specific numerical systems. These examples show how to compute the controllability and observability matrices, evaluate the rank, and connect the result back to the transfer function.
      </p>
      <DiagramNumericExamples/>

      <h2 style={S.h2}>The PBH Eigenvalue Test</h2>
      <p style={S.p}>
        The Popov-Belevitch-Hautus (PBH) test provides an eigenvalue-by-eigenvalue diagnosis of controllability and observability. Rather than checking the entire controllability matrix, it tests each eigenvalue of A individually by forming an augmented matrix. This makes it easy to identify precisely which mode is uncontrollable or unobservable  --  and why.
      </p>
      <DiagramPBH/>
      <Table2 rows={[
        ["PBH controllability test","(A, B) controllable &lt;=&gt; rank[lambdaI-A  B] = n  for every eigenvalue lambda of A\nEquivalently: no left eigenvector of A is orthogonal to all columns of B"],
        ["PBH observability test","(A, C) observable &lt;=&gt; rank[lambdaI-A ; C] = n  for every eigenvalue lambda of A\nEquivalently: no right eigenvector of A lies in the null space of C"],
        ["Geometric interpretation","Uncontrollable: exists vT with vTA=lambdavT and vTB=0 -> mode at lambda is 'B-orthogonal'\nUnobservable: exists v with Av=lambdav and Cv=0 -> mode at lambda is in ker(C)"],
        ["How to apply","For each eigenvalue lambdai: form [lambdaiI-A | B] (controllability) or [lambdaiI-A ; C] (observability)\nCompute rank numerically via SVD  --  check for rank deficiency (small singular values)"],
        ["Connection to TF","Mode at lambda uncontrollable AND unobservable &lt;-&gt; pole-zero cancellation at s=lambda in G(s)\nMissing from G(s) = hidden internal dynamics  --  requires state-space analysis to detect"],
        ["Repeated eigenvalues","More subtle: Jordan block with repeated lambda may be partially controllable\nMust check each Jordan block separately  --  PBH test extends naturally"],
      ]}/>

      <h2 style={S.h2}>Pole-Zero Cancellation and Hidden Modes</h2>
      <p style={S.p}>
        The transfer function G(s) is a compressed description of the system  --  it only captures what the input can excite AND the output can observe. When a pole cancels with a zero, the corresponding internal mode is hidden from the input-output description. This is harmless if the hidden mode is stable, but potentially catastrophic if it is unstable.
      </p>
      <DiagramPoleZero/>
      <Table2 rows={[
        ["Cancellation rule","Pole-zero cancellation at s=lambda in G(s):\n&lt;-&gt; mode at lambda is uncontrollable, OR unobservable, OR both"],
        ["Stable cancellation","Cancelled stable pole: mode decays on its own\nWaste of state dimension (non-minimal realization) but not dangerous"],
        ["Unstable cancellation","Cancelled unstable pole: mode grows without bound internally\nG(s) looks fine, but the true system is internally unstable  --  VERY DANGEROUS"],
        ["Minimal realization","G(s) has a unique minimal state-space realization: no cancellations\nAll modes are both controllable and observable in a minimal realization"],
        ["Detection","Always verify rank(C) = n AND rank(O) = n for ANY state-space model\nNever design a controller from G(s) alone without checking internal stability"],
        ["Consequence for design","A controller stabilising G(s) does NOT stabilise cancelled unstable internal modes\nMust use the full state-space (nxn) model  --  or use output stabilisability test"],
      ]}/>

      <h2 style={S.h2}>Duality Principle</h2>
      <p style={S.p}>
        One of the most elegant results in control theory is the exact duality between controllability and observability. The controllability of (A, B) is mathematically equivalent to the observability of the dual system (AT, CT). This means every theorem, algorithm, and formula for controllability has a direct counterpart for observability  --  obtained simply by transposing matrices.
      </p>
      <DiagramDuality/>
      <Table2 rows={[
        ["Duality theorem","(A, B) controllable &lt;=&gt; (AT, BT) observable\n(A, C) observable &lt;=&gt; (AT, CT) controllable"],
        ["Practical consequence","Observer gain L can be found by pole placement on (AT, CT)\nL = (K_dual)T where K_dual = place(AT, CT, desired_observer_poles)"],
        ["Ackermann dual","L = phi(A) . O-1 . en   (Ackermann's formula for observers)\nMirrors K = enT . C-1 . phi(A) for controllers"],
        ["Gramian duality","Controllability Gramian Wc solves: AWc + WcAT + BBT = 0\nObservability Gramian Wo solves: ATWo + WoA + CTC = 0  (exact dual Lyapunov)"],
        ["Design implication","Design K for (A,B) using place/LQR -> same algorithm gives L for (AT,CT)\nMatlab: K=place(A,B,p) ; L=place(A',C',p_obs)'  --  exactly dual"],
        ["Separation principle","Closed-loop poles = eig(A-BK) u eig(A-LC)  (independent by duality)\nK chosen for performance; L chosen for observer speed (typically 2-5x faster)"],
      ]}/>

      <h2 style={S.h2}>Kalman Decomposition</h2>
      <p style={S.p}>
        The Kalman decomposition is the theoretical culmination of controllability and observability analysis. It shows that any linear system can be transformed into a block upper-triangular form that makes explicit the four canonical subspaces: controllable-observable, controllable-unobservable, uncontrollable-observable, and uncontrollable-unobservable. The transfer function only captures the first of these four.
      </p>
      <DiagramKalmanDecomposition/>
      <Table2 rows={[
        ["Four subspaces","x_co: controllable AND observable  --  the minimal system, visible in G(s)\nx_c:  controllable but unobservable  --  can drive it, but can't see its effect\nx_o:  observable but uncontrollable  --  can see it, but can't affect it\nx_nc: neither  --  completely decoupled from both input and output"],
        ["Block structure of A","Upper triangular: A = [[A_co *  *  *]; [0  A_c  *  *]; [0  0  A_o  *]; [0  0  0  A_nc]]\nOff-diagonal * entries show coupling from right subspaces to left"],
        ["Transfer function","G(s) = C_co (sI - A_co)-1 B_co + D\nOnly x_co contributes; other subspaces produce hidden but real internal dynamics"],
        ["Minimal realization","Realization is minimal iff x_c = x_o = x_nc = {0}\ni.e., every state is both controllable and observable  --  no cancellation in G(s)"],
        ["Change of basis T","T = [basis of (x_co n C); basis of (x_co complement in C); ...]\nT must be carefully constructed; state x = T x preserves all input-output properties"],
        ["Application: model reduction","Truncate modes with small Hankel singular values (small sigmai = sqrtlambdai(WcWo))\nReduced model G_r(s) approximates G(s) with ||G-Gr||_inf bounded by 2Sigmai discarded sigmai"],
      ]}/>

      <h2 style={S.h2}>Gramian Matrices  --  Quantifying the Degree</h2>
      <p style={S.p}>
        The rank tests tell us whether a system is controllable or observable. The Gramian matrices go further, telling us <em>how much</em>  --  which directions in state space are easy or hard to control and observe. They are symmetric positive semidefinite matrices whose eigenvectors point along the most and least controllable/observable directions.
      </p>
      <DiagramGramians/>
      <Table2 rows={[
        ["Controllability Gramian","Wc = int0^inf e^(At) BBT e^(ATt) dt  (converges if A is stable)\nSolve Lyapunov: AWc + WcAT + BBT = 0  (MATLAB: lyap(A, B*B'))"],
        ["Observability Gramian","Wo = int0^inf e^(ATt) CTC e^(At) dt  (converges if A is stable)\nSolve Lyapunov: ATWo + WoA + CTC = 0  (MATLAB: lyap(A', C'*C))"],
        ["Minimum energy interpretation","Minimum energy to steer x0 -> 0: J* = x0T Wc-1 x0\nDirections with small eigenvalues of Wc -> require large input energy"],
        ["Output energy interpretation","Total output energy from initial state x0: ||y||22 = x0T Wo x0\nDirections with small eigenvalues of Wo -> contribute little to output"],
        ["Hankel singular values","sigmai = sqrtlambdai(Wc Wo)  --  measures importance of mode i for input-output map\nSorted sigma1 >= sigma2 >= ... >= sigman; truncating small sigmai gives reduced-order model"],
        ["Balanced truncation","Coordinate transform T: T Wc TT = T-T Wo T-1 = diag(sigma1,...,sigman)\nTruncate states with sigmai < eps; error bound ||G-Gr||_inf <= 2(sigma_{r+1}+...+sigman)"],
      ]}/>

      <h2 style={S.h2}>Stabilisability and Detectability</h2>
      <p style={S.p}>
        Full controllability and observability are sufficient but not always necessary for practical control. Stabilisability and detectability are weaker conditions that are both necessary and sufficient for the existence of a stabilising output-feedback controller: the system need only have its unstable modes be controllable (stabilisable) and observable (detectable).
      </p>
      <DiagramStabilisability/>
      <Table2 rows={[
        ["Stabilisability","(A,B) stabilisable iff every uncontrollable mode is stable (Re(lambda) < 0)\nPBH: rank[lambdaI-A B]=n for all lambda with Re(lambda)>=0"],
        ["Detectability","(A,C) detectable iff every unobservable mode is stable (Re(lambda) < 0)\nPBH: rank[lambdaI-A; C]=n for all lambda with Re(lambda)>=0"],
        ["Minimal conditions","Output-feedback stabilising controller exists iff system is stabilisable AND detectable\nKey theorem: necessary AND sufficient  --  not just sufficient"],
        ["LQR/LQG requirement","LQR requires stabilisability of (A,B) and detectability of (A,Q^{1/2})\nLQG (Kalman filter) requires detectability of (A,C) and stabilisability of (A,R^{1/2}BT)"],
        ["Design implication","If a system is stabilisable but not fully controllable:\nStable uncontrollable modes don't need pole placement  --  they're self-stabilising"],
        ["Testing in MATLAB","Stabilisable: all(real(eig(A(~ctrl_idx,~ctrl_idx)))<0) after Kalman decomp\nOr: check PBH rank for all RHP eigenvalues using rank([lambda*eye(n)-A B]) for each lambda"],
      ]}/>

      <h2 style={S.h2}>Summary: Complete Controllability & Observability Checklist</h2>
      <Table2 rows={[
        ["Step 1  --  Compute C","C = ctrb(A,B) in MATLAB\nCheck: rank(C) vs n. If rank < n, identify which modes fail PBH test"],
        ["Step 2  --  Compute O","O = obsv(A,C) in MATLAB\nCheck: rank(O) vs n. If rank < n, identify unobservable modes via PBH"],
        ["Step 3  --  Check TF","Compare TF G(s) poles with eigenvalues of A\nAny missing pole = hidden mode (cancelled)  --  check if stable or unstable"],
        ["Step 4  --  Gramians","Solve Lyapunov equations for Wc, Wo\nCompute sigmai = sqrtlambdai(WcWo)  --  assess if any modes are near-uncontrollable/observable"],
        ["Step 5  --  Stabilisability","If not fully controllable: check if uncontrollable modes are stable\nIf stabilisable: feedback can still stabilise; design K for controllable modes only"],
        ["Step 6  --  Detectability","If not fully observable: check if unobservable modes are stable\nIf detectable: observer will still converge; Kalman filter handles this automatically"],
        ["Step 7  --  Design","If rank(C)=n: proceed with full pole placement (Ackermann/place/LQR)\nIf rank(O)=n: proceed with full observer design (dual pole placement/Kalman filter)"],
      ]}/>

      <InfoBox title="Key Formulae and Tests Summary" items={[
        "Controllability matrix:  C = [B  AB  A2B  ...  An-1B]   ->  controllable iff rank(C) = n",
        "Observability matrix:   O = [CT  ATCT  ...  (AT)n-1CT]T   ->  observable iff rank(O) = n",
        "PBH controllability:  rank[lambdaI-A  |  B] = n  for every eigenvalue lambda of A",
        "PBH observability:    rank[lambdaI-A ;  C] = n  for every eigenvalue lambda of A",
        "Duality:  (A,B) controllable  &lt;=&gt;  (AT,BT) observable  |  design L = place(AT,CT,p)T",
        "Controllability Gramian:  AWc + WcAT + BBT = 0  (Lyapunov equation)",
        "Observability Gramian:  ATWo + WoA + CTC = 0  (dual Lyapunov equation)",
        "Hankel singular values:  sigmai = sqrtlambdai(Wc Wo)   --  measures mode importance for model reduction",
        "Stabilisable + Detectable  &lt;=&gt;  stabilising output-feedback controller exists (necessary & sufficient)",
      ]}/>
    </div>
  );
}